/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: OptionsTab.tsx
 * Project: mle-client-n
 * Committed last: 2022/2/9 @ 1745
 * ---
 * Description:
 */

import { Editor }          from '../../../../store/observables/Editor';
import React, { useState } from 'react';
import { Button, Intent }  from '@blueprintjs/core';
import { DevDataOverlay }  from '../../../overlay/DevDataOverlay';
import {
  DeletionConfirmPopver
}                          from '../../../common/overlay/DeletionConfirmPopver';

interface OptionsTabProps {
  editor: Editor;
}

export const OptionsTab = (props: OptionsTabProps) => {
  const [ devDataIsOpen, setDevDataIsOpen ] = useState(false);

  return (
    <div>
      <div className="bp4-text-muted mle-info-heading">OPZIONI</div>
      <DeletionConfirmPopver
        onConfirm={ async () => await props.editor.deleteSelectedShape() }>
        <Button
          small
          intent={ Intent.DANGER }
          icon="trash"
        >
          Elimina forma
        </Button>
      </DeletionConfirmPopver>
      <Button
        small
        className="mt-2"
        icon="code-block"
        onClick={ () => setDevDataIsOpen(true) }
      >
        Informazioni per sviluppatori
      </Button>

      <DevDataOverlay
        editor={ props.editor }
        onClose={ () => setDevDataIsOpen(false) }
        isOpen={ devDataIsOpen }
      />
    </div>
  );
};
